const re = /(\.xls|\.xlsx|\.csv|)$/i;

export const checkFileExtension = (file) => {
    //console.log(file);
    return(re.exec(file.name))
}